exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".black[data-v-03cf24d0]{color:#fff;height:50px;font-size:20px;font-weight:700}.black1[data-v-03cf24d0]{line-height:40px;font-size:18px}img[data-v-03cf24d0]{width:100%}", ""]);

// exports
